export const roomsSelectors = {
  getRoomRateAvailability: (state) => state.rooms.availability,
};
